// Опубликованный пользовательский раздел `custom:<id>` (README §10): модель
// с сервера → SectionRenderer. Если у раздела есть черновик — сверху шапка
// черновика «принять / отменить / версии».

import { useAppStore } from '../../store/appStore'
import { SideMenu } from '../../ui/SideMenu'
import { SectionStub } from '../Stub'
import type { SectionModule } from '../types'
import { DraftBar, VersionsButton } from './DraftBar'
import { useSectionModel } from './model'
import { SectionCanvas, SectionSidebar } from './SectionRenderer'
import { useSections } from './store'
import './custom.css'

function useId(): string | null {
  const section = useAppStore((s) => s.section)
  return section.startsWith('custom:') ? section.slice(7) : null
}

function Sidebar() {
  const id = useId()
  const entry = useSectionModel(id, false)
  if (!id || !entry?.model) return <SideMenu screen="custom" sections={[]} />
  return <SectionSidebar sectionId={id} model={entry.model} draft={false} />
}

function View() {
  const id = useId()
  const entry = useSectionModel(id, false)
  const summary = useSections((s) => (id ? s.list.find((x) => x.id === id) : undefined))
  if (!id) return null
  if (entry?.missing) {
    return <SectionStub title="Раздела нет" lead="Его удалили или ещё не опубликовали. Вкладка исчезнет при следующем обновлении списка." />
  }
  if (!entry?.model) return <div className="abx-sr-wait" />
  return (
    <>
      {summary?.hasDraft ? <DraftBar id={id} title={summary.draftTitle || entry.model.title} preview={false} /> : null}
      <SectionCanvas
        sectionId={id}
        model={entry.model}
        draft={false}
        panelExtra={summary?.hasDraft ? undefined : <VersionsButton id={id} className="abx-float__btn tone-plain" />}
      />
    </>
  )
}

const custom: SectionModule = { Sidebar, View }
export default custom
